import { EmbeddableLocation } from '../EmbeddableLocation';
import { ShipmentStopType } from '../shipment/ShipmentStopType';
import { ShipOrderShippingPoint } from '../ShipOrderShippingPoint';

import { PlanningStatus } from './PlanningStatus';

export class ValidShipOrderShippingPoint extends ShipOrderShippingPoint {
  id: number;
  shippingPointType: ShipmentStopType.PICKUP | ShipmentStopType.DROP_OFF;
  planningStatus: PlanningStatus.UNPLANNED | PlanningStatus.PLANNED =
    PlanningStatus.UNPLANNED;

  constructor(opts?: Partial<ValidShipOrderShippingPoint>) {
    super(opts);

    if (opts?.id) {
      this.id = opts.id;
    } else {
      throw new Error('Invalid Shipping Point - id is required');
    }

    if (opts?.location) {
      this.location = new EmbeddableLocation(opts.location);
    } else {
      throw new Error('Invalid Shipping Point - location is required');
    }

    if (opts?.shippingPointType) {
      this.shippingPointType = opts.shippingPointType;
    } else {
      throw new Error('Invalid Shipping Point - shippingPointType is required');
    }

    if (opts?.planningStatus) {
      this.planningStatus = opts.planningStatus;
    }
  }
}
